import axios from 'axios';
import { Vehicle } from '../types';

const hostname = window.location.hostname;

let COMPANY_ID = 1;
let API_BASE_URL = "https://api.carmanager.com.br";

if (hostname.includes('carmanager')) {
  API_BASE_URL = 'https://api.carmanager.com.br';
}

if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('127.')) {
  COMPANY_ID = 2
}

if (hostname.includes('gestao')) {
  COMPANY_ID = 1

}
if (hostname.includes('jfcars')) {
  COMPANY_ID = 2
}

if (hostname.includes('rmotors')) {
  COMPANY_ID = 3
}

export const PUBLIC_API_BASE_URL = `${API_BASE_URL}/api/`;
export const PUBLIC_COMPANY_ID = COMPANY_ID;

// Vitrine é pública: nunca envia o token de login da área administrativa.
export const publicApi = axios.create({
  baseURL: PUBLIC_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'company-x': COMPANY_ID
  },
});

export const publicVehicleService = {
  getAvailableVehicles: async (): Promise<Vehicle[]> => {
    try {
      const response = await publicApi.get<Vehicle[]>('/public/vehicles/available');
      return response.data || [];
    } catch {
      console.error('Erro ao buscar veículos públicos:');
      return [];
    }
  },

  getVehicleById: async (id: string | number): Promise<Vehicle | null> => {
    try {
      const response = await publicApi.get<Vehicle>(`/public/vehicles/${id}`);
      return response.data ?? null;
    } catch {
      // API antiga sem a rota de detalhe: procura na lista de disponíveis.
      const list = await publicVehicleService.getAvailableVehicles();
      return list.find((v) => String(v.id) === String(id)) ?? null;
    }
  },
};
